import React from 'react';
import type { FeatureFlags } from 'constants/feature-flags';
import { localFeatureFlagValues } from 'constants/feature-flags';

export type FeatureFlagsContextValue = {
  featureFlags: FeatureFlags;
  isInitialized: boolean;
  didInitializationFail: boolean;
};

export const featureFlagsDefaultValue: FeatureFlagsContextValue = {
  featureFlags: localFeatureFlagValues,
  isInitialized: false,
  didInitializationFail: false
};

export const FeatureFlagsContext = React.createContext<FeatureFlagsContextValue>(featureFlagsDefaultValue);
